module.exports = __webpack_public_path__ + "static/media/tata_logo.4870f56e.svg";